<template>
  <div>
    <app-table :id="tableId" :options="options" @action="getListAction" />

    <review-objections-308-modal
      v-if="isAddEditModalActive"
      :modalTitle="modalTitle"
      :editModalTitle="editModalTitle"
      :table-id="tableId"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
      modalId="modal-add-edit"
    />
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import * as actions from "../../../apiUrl";
import { TableHelpers } from "./TableHelpers";

export default {
  extends: CoreLibrary,
  mixins: [TableHelpers],
  data() {
    return {
      tableId: "planning-approval-table",
      rowData: {},
      options: {
        name: "planning-approval-table",
        url: `${actions.ACCREDITATION_REVIEW}/evaluationTeam/reviewObjections`,
        showHeader: true,
        columns: [],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            component: "planning-approval-302-modal",
            modalId: "modal-add-edit",
          },
        ],
        showFilter: false,
        showSearch: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "default",
      },
      isAddEditModalActive: false,
      modalTitle: "Revisar Objeción",
      editModalTitle: "Revisar Objeción",
    };
  },
  created() {
    this.$hub.$on("reload-table", this.reloadTable);
    this.options.columns = [...this.tableColumns, this.actionObj];
  },
  methods: {
    reloadTable: function () {
      this.$hub.$emit("reload-" + this.tableId);
    },

    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    closeAddEditModal() {
      $("#modal-add-edit").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },

    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("delete")) {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `${actions.ACCREDITATION_REVIEW}/evaluationTeam/reviewObjections/${rowData.id}`;
        this.openAddEditModal();
      }
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },

    data() {},
  },
};
</script>
